function FactCheck({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '20'} height=${(dimensions * 9) / 10 || '18'} viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M18 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H18C19.1 18 20 17.1 20 16V2C20 0.9 19.1 0 18 0ZM18 16H2V2H18V16Z" fill=${`"${col}"`} />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M17.41 7.42L15.99 6L12.82 9.17L11.41 7.75L10 9.16L12.82 12L17.41 7.42Z" fill=${`"${col}"`} />
      <path d="M8 4H3V6H8V4Z" fill=${`"${col}"`} />
      <path d="M8 8H3V10H8V8Z" fill=${`"${col}"`} />
      <path d="M8 12H3V14H8V12Z" fill=${`"${col}"`} />
    </svg>

  `;

  return baseXml;
}

export default FactCheck;
